export default class AgendaItem
{
  constructor(titles, texts, buttonPrimaries, buttonSecondaries, buttonSecondaryLinks, photo, icon) 
  {
    // {} instead of array to support stringify
    this.titles = titles;
    this.texts = texts;
    this.buttonPrimaries = buttonPrimaries;
    this.buttonSecondaries = buttonSecondaries;
    this.buttonSecondaryLinks = buttonSecondaryLinks;

    this.photo = photo;
    this.icon = icon;
  }    

  isValid()
  {
    var result = true;

    for (const [key, value] of Object.entries(this.titles)) { if(!value) { result = false; break; }; }
    if(result) for (const [key, value] of Object.entries(this.titles)) { if(!value) { result = false; break; }; }
    if(result) for (const [key, value] of Object.entries(this.texts)) { if(!value) { result = false; break; }; }
    if(result) for (const [key, value] of Object.entries(this.buttonPrimaries)) { if(!value) { result = false; break; }; }

    if(result) result = Boolean(this.photo);
    // ButtonSecondaries, ButtonSecondaryLinks and Icon are optional

    return result;
  }
}